import theme from '@vromo/ui/components/theme';
import { css } from 'emotion';

export default {
    pageContainer: css`
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0px 16px;
        position: relative;
    `,
    tableContainer: css`
        width: 100%;
        overflow: auto;
        margin-top: 15px;
    `,
    rowContainer: css`
        cursor: pointer;
    `,
    profile: css`
        text-align: center;
        width: 50px;
    `,
    warning: css`
        color: ${theme.warn};
    `,
    warningIcon: css`
        padding-right: 5px;
    `
};
